import { getInstance, init, registerRemotes } from '@module-federation/runtime';

import type { ModuleVersionMap } from './types';
import { resolveRemotes } from './version-map';

let lastSignature = '';
let registeredRemoteEntries = new Map<string, string>();

type TenantRemote = ReturnType<typeof resolveRemotes>[number];

function rememberRemotes(remotes: TenantRemote[]): void {
  registeredRemoteEntries = new Map([
    ...registeredRemoteEntries,
    ...remotes.map(remote => [remote.name, remote.entry] as const),
  ]);
}

function getRuntimeRemoteEntries(): Map<string, string> {
  const remotes = getInstance()?.options.remotes ?? [];
  return new Map(
    remotes
      .map((remote) => {
        if (!('entry' in remote)) return null;
        return [remote.name, remote.entry] as const;
      })
      .filter((remote): remote is readonly [string, string] => Boolean(remote)),
  );
}

function filterChangedRemotes(remotes: TenantRemote[]): TenantRemote[] {
  const runtimeRemoteEntries = getRuntimeRemoteEntries();
  return remotes.filter((remote) => {
    const registeredEntry = registeredRemoteEntries.get(remote.name) ?? runtimeRemoteEntries.get(remote.name);
    return registeredEntry !== remote.entry;
  });
}

export function initRemotes(versionMap: ModuleVersionMap): void {
  const remotes = resolveRemotes(versionMap);
  const signature = JSON.stringify(remotes);
  if (signature === lastSignature) return;
  lastSignature = signature;

  init({
    name: 'tenant-web',
    remotes,
  });
  rememberRemotes(remotes);
}

export function registerTenantRemotes(versionMap: ModuleVersionMap): void {
  const remotes = filterChangedRemotes(resolveRemotes(versionMap));
  if (!remotes.length) return;
  registerRemotes(remotes, { force: true });
  rememberRemotes(remotes);
}
